import type { ReactNode } from 'react';

interface ITabOption<T extends string> {
  label: string;
  value: T;
}

interface ITabsProps<T extends string> {
  options: ITabOption<T>[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
  action?: ReactNode;
}

export const Tabs = <T extends string>({
  options,
  value,
  onChange,
  className = '',
  action,
}: ITabsProps<T>) => {
  return (
    <div className={`border-b border-neutral-light-200 ${className}`}>
      <div className="flex items-center justify-between">
        <div className="flex gap-8">
          {options.map((tab) => (
            <button
              key={tab.value}
              type="button"
              onClick={() => onChange(tab.value)}
              className={`
                pb-4 text-sm font-medium transition-colors relative cursor-pointer
                ${
                  value === tab.value
                    ? 'text-brand-default'
                    : 'text-neutral-secondary hover:text-neutral-primary'
                }
              `}
            >
              {tab.label}
              {value === tab.value && (
                <span className="absolute bottom-0 start-0 end-0 h-0.5 bg-brand-default" />
              )}
            </button>
          ))}
        </div>
        <div className="shrink-0">{action}</div>
      </div>
    </div>
  );
};
